<template>
  <div>
    <h1 v-bg-typography="'h1'">Create Test</h1>
    <p v-bg-typography="'body-m'">
      This form is for creating a test.
      <a
        href="https://braingineers.crunch.help/dashboard-faq/create-a-new-test"
        target="_blank"
        class="link"
        >Read more</a
      >.
    </p>
    <bg-field
      label="Test type"
      directions="Please select the test type."
      name="name"
    >
      <div class="select-holder">
        <bg-big-checkbox
          class="select-item"
          label="Website & apps"
          :link="() => navigateToTest('/web')"
        >
          <img :src="images.desktop" class="img" alt="desktop-placeholder" />
        </bg-big-checkbox>
        <bg-big-checkbox
          :link="() => navigateToTest('/video')"
          label="Videos"
          class="select-item"
        >
          <img :src="images.video" class="img2" alt="desktop-placeholder" />
        </bg-big-checkbox>
      </div>
    </bg-field>
  </div>
</template>

<style lang="scss" scoped>
.input-holder {
  max-width: 800px;
}
.select-holder {
  display: flex;
}

.select-item {
  margin-right: 20px;
}
.action-container {
  display: flex;
  margin-bottom: 200px;
}
.action {
  margin-right: 20px;
}
.pick-icon {
  height: 45px;
  width: 45px;
  margin-bottom: 1rem;
}
.brain-image {
  height: 90px;
  width: 90px;
  margin-bottom: 20px;
}

.brain-image--active {
  color: white;
}
.mb {
  margin-bottom: 10px;
}

.img {
  margin-bottom: -65px;
}

.img2 {
  margin-bottom: 34px;
}

.link {
  color: var(--bg-color-text-link);
}
</style>

<script>
import BgTypography from "@/directives/bg-typography";
import BgSelect from "@/components/bg-select";
import BgBigCheckbox from "@/components/bg-big-checkbox";
import BgButton from "@/components/bg-button";
import BgField from "@/components/bg-field";
import BgInput from "@/components/bg-input";
import BgLoader from "@/components/bg-loader";
import BgFilterBubble from "@/components/bg-filter-bubble";
import BgSplashCard from "@/components/bg-splash-card";
import BgBanner from "@/components/bg-banner";
import BgIcon from "@/components/bg-icon";
import { mapState } from "vuex";
import API from "@/api";

export default {
  name: "BgTests",
  components: {
    BgSelect,
    BgField,
    BgInput,
    BgBigCheckbox,
    BgButton,
    BgLoader,
    BgIcon,
    BgBanner,
  },
  directives: {
    BgTypography,
  },
  methods: {
    navigateToTest(type) {
      this.$router.push({
        path: `/create-test${type}`,
      });
    },
  },
  data() {
    return {
      images: {
        video: require("@/assets/imgs/placeholder_video.svg"),
        desktop: require("@/assets/imgs/placeholder_desktop.svg"),
      },
    };
  },
};
</script>
